/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';
import cx from '@/utils/cx';

const ListItem = ({
  children,
  index,
  onSelect,
  className,
  highlighted,
  onClick,
  ...rest
}) => {
  const classes = useStyle();

  return (
    <li
      className={cx(classes.listItem, className, highlighted === index && 'highlighted')}
      data-index={index}
      {...(highlighted === index ? { 'data-highlighted': true } : {})}
      onClick={onClick}
      tabIndex="-1"
      {...rest}
    >
      {children}
    </li>
  );
};

ListItem.propTypes = {
  onSelect: PropTypes.func,
};

ListItem.defaultProps = {
  onSelect: () => {},
};

export default ListItem;
